import React from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import CatalogSelect from "./CatalogSelect";

const LOCATION_FIELDS = [
  { suffix: "Province", label: "Provincia", required: true },
  { suffix: "Municipality", label: "Municipio", required: true },
  { suffix: "Sector", label: "Sector" },
];

const LocationFields = ({ prefix, form, provinces, municipalities, sectors, inlineErrors, onChange, showInlineError, disabled }) => {
  const catalogs = { Province: provinces, Municipality: municipalities, Sector: sectors };
  const parents = { Municipality: "Province", Sector: "Municipality" };

  return (
    <Row form>
      {LOCATION_FIELDS.map(({ suffix, label, required }) => {
        const field = `${prefix}${suffix}`;
        return (
          <Col md={4} key={field}>
            <FormGroup>
              <Label for={field}>{label}{required && <span className="required-mark"> *</span>}</Label>
              <CatalogSelect inputId={field} options={catalogs[suffix]} value={form[field]}
                invalid={Boolean(inlineErrors[field])}
                disabled={disabled || Boolean(parents[suffix] && !form[`${prefix}${parents[suffix]}`])}
                onChange={(value) => onChange(field, value)} />
              {showInlineError(field)}
            </FormGroup>
          </Col>
        );
      })}
    </Row>
  );
};

export default LocationFields;
